import { InfoOutlined, Menu } from '@mui/icons-material';
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { tenant } from '../../config/tenant';
import { handleLogout } from '../../services/session';
import { useUserStore } from '../../stores';
import { getImageUrl, UserRole } from '../../utils';
import { InfoDrawer } from '../info-drawer';
import { PropostasSuperadasMenu } from '../notification-propostas-superadas';
import {
	HambugerButton,
	HeaderContainer,
	InfoButton,
	LeftDiv,
	Li,
	Nav,
	Ul,
	UserInfo,
} from './Header.styles';

interface PageInterface {
	name: string;
	path: string;
}

const Header: React.FC = () => {
	const { user } = useUserStore();
	const [openInfoDrawer, setOpenInfoDrawer] = useState(false);
	const [expandedMenu, setExpandedMenu] = useState(false);
	const [pages, setPages] = useState<PageInterface[]>([]);

	const handleOpenInfoDrawer = () => {
		setOpenInfoDrawer(true);
	};

	const handleExpandMenu = () => {
		setExpandedMenu(!expandedMenu);
	};

	useEffect(() => {
		const adminPages: PageInterface[] = [
			{ name: 'Home', path: '/admin/relatorios' },
			{ name: 'Anúncios', path: '/anuncios' },
			{ name: 'Financeiro', path: '/financeiro' },
			{ name: 'Cadastros', path: '/cadastros' },
			{ name: 'Relatórios', path: '/relatorios' },
			{ name: 'Indicação', path: '/indicacao' },
			{ name: 'Conta', path: '/minha-conta' },
			{ name: 'Sair', path: '/logout' },
		];

		const shopkeeperPages: PageInterface[] = [
			{ name: 'Home', path: '/' },
			{ name: 'Anúncios', path: '/anuncios' },
			{ name: 'Indicação', path: '/indicacao' },
			{ name: 'Minha Conta', path: '/minha-conta/lojista' },
			{ name: 'Sair', path: '/logout' },
		];

		const dealerPages: PageInterface[] = [
			{ name: 'Home', path: '/admin/relatorios' },
			{ name: 'Anúncios', path: '/anuncios' },
			{ name: 'Relatórios', path: '/relatorios' },
			{ name: 'Indicação', path: '/indicacao' },
			{ name: 'Minha Conta', path: '/minha-conta' },
			{ name: 'Sair', path: '/logout' },
		];

		switch (user?.grupoAcesso?.id.toString()) {
			case UserRole.Admin:
				setPages(adminPages);
				break;
			case UserRole.Dealer:
				setPages(dealerPages);
				break;
			case UserRole.Shopkeeper:
				setPages(shopkeeperPages);
				// setPages(adminPages);
				break;
			default:
				setPages([]);
				break;
		}
	}, [user?.grupoAcesso?.id]);

	if (!user) {
		return (
			<HeaderContainer $expanded={false}>
				<Nav>
					<LeftDiv>
						<Link to='/'>
							<img src={getImageUrl.logoPadrao()} alt='Início' />
						</Link>
						<UserInfo>
							<span>Olá, Visitante!</span>
							<span>{tenant.appName}</span>
						</UserInfo>
					</LeftDiv>
				</Nav>
			</HeaderContainer>
		);
	}

	return (
		<HeaderContainer $expanded={expandedMenu}>
			<InfoDrawer open={openInfoDrawer} setOpen={setOpenInfoDrawer} />
			<Nav>
				<LeftDiv>
					<Link to='/'>
						<img src={getImageUrl.logoPadrao()} alt='Início' />
					</Link>
					<UserInfo>
						<span>Olá, {user.nome.split(' ')[0]}!</span>
						<span>Perfil: {user.grupoAcesso.nome}</span>
					</UserInfo>
					<HambugerButton onClick={handleExpandMenu}>
						<Menu fontSize='inherit' />
					</HambugerButton>
				</LeftDiv>
				<Ul>
					{pages.map((page) => (
						<Li key={page.name}>
							<NavLink
								to={page.path}
								onClick={page.name === 'Sair' ? handleLogout : handleExpandMenu}
							>
								{page.name}
							</NavLink>
						</Li>
					))}
				</Ul>
				{user.grupoAcesso?.id.toString() === UserRole.Shopkeeper && (
					<>
						<PropostasSuperadasMenu />
						<InfoButton style={{ position: 'relative', right: '5px' }} onClick={handleOpenInfoDrawer}>
							<InfoOutlined fontSize='inherit' />
						</InfoButton>
					</>
				)}
			</Nav>
		</HeaderContainer>
	);
};

export default Header;
